import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/app/routes/root'
import { lazyPage } from '@/lib/lazy-page'
import { invitationsGridContract, normalizeDataGridUrlState } from '@/modules/data-grid'
import { userManagementScopeRoute } from '@/modules/iam'

type AcceptInviteSearch = { token: string }

export const AcceptInviteRoute = lazyPage(
  () => import('./features/accept-invite/accept-invite.lazy'),
  'AcceptInviteRoute',
)
export const SendInvite = lazyPage(() => import('./features/send-invite/send-invite.lazy'), 'SendInvite')
export const EntityInvitations = lazyPage(
  () => import('./features/entity-invitations/entity-invitations.lazy'),
  'EntityInvitations',
)

export type EntityInvitationsSearch = {
  q?: string
  qColumns?: string
  filters?: string
  sort?: string
  columns?: string
}

export function decodeEntityInvitationsSearch(
  search: Record<string, unknown>,
): EntityInvitationsSearch {
  return normalizeDataGridUrlState(search, invitationsGridContract)
}

export const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accept-invite',
  validateSearch: (search: Record<string, unknown>): AcceptInviteSearch => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: AcceptInviteRoute,
})

export const sendInviteRoute = createRoute({
  getParentRoute: () => userManagementScopeRoute,
  path: 'invitations/send',
  component: SendInvite,
})

export const entityInvitationsRoute = createRoute({
  getParentRoute: () => userManagementScopeRoute,
  path: 'invitations',
  validateSearch: decodeEntityInvitationsSearch,
  component: EntityInvitations,
  staticData: { title: 'Invitations' },
})
